import styled, { css } from 'styled-components';

import { Chevron } from '@solent-university/solent-icons';

import scrollBarStyle from 'Common/styles/scrollbar';

export const Wrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
`;

export const Container = styled.div`
    position: relative;
    flex-grow: 1;
    user-select: none;
`;

export const InputBox = styled.button<{ $isOpen: boolean }>`
    ${({ theme, $isOpen }) => css`
        position: relative;
        display: block;
        height: 100%;
        width: 100%;
        font-size: 1.125rem;
        text-align: left;
        line-height: normal;
        color: inherit;
        padding: 0.5rem 2rem 0.5rem 1rem;
        background-color: ${theme.colors.primaryContrast.hex};
        border-radius: 0.4rem;
        border: 0.0625rem solid ${theme.elements.input.border};
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;

        ${$isOpen &&
        css`
            border-radius: 0.4rem 0.4rem 0 0;
        `}

        &:focus ${ChevronSVG} {
            outline: 0.1rem solid ${theme.elements.input.border};
            outline-offset: 0.2rem;
        }
    `}
`;

export const ChevronSVG = styled(Chevron)<{ $isOpen: boolean }>`
    ${({ $isOpen }) => css`
        position: absolute;
        right: 0.75rem;
        top: 50%;
        margin: 0 auto;
        height: 0.75rem;
        width: 0.5rem;
        transform: ${$isOpen
            ? `translateY(-50%) rotate(-90deg)`
            : `translateY(-50%) rotate(90deg)`};
        transform-origin: center;
        transition: 200ms ease;
        color: inherit;
    `}
`;

export const DropDown = styled.ul<{ $isOpen: boolean }>`
    ${({ theme, $isOpen }) => css`
        position: absolute;
        left: 0;
        right: 0;
        top: calc(100% - 0.125rem);
        margin: 0;
        height: 0;
        max-height: 20rem;
        font-size: 1.125rem;
        overflow-y: auto;
        border: 0rem;
        background-color: ${theme.colors.secondary.hex};
        z-index: 100;
        padding-left: 0rem;
        ${scrollBarStyle()}

        ${$isOpen &&
        css`
            height: auto;
            border: 0.0625rem solid ${theme.colors.secondary.tints[1].hex};
            border-radius: 0 0 0.5rem 0.5rem;
        `}
    `}
`;

export const Option = styled.li`
    ${({ theme }) => css`
        cursor: pointer;
        list-style: none;

        &:not(:last-child) {
            border-bottom: 0.0625rem solid ${theme.colors.secondary.tints[1].hex};
        }
    `}
`;

export const OptionLabel = styled.div<{ $isHovered }>`
    ${({ $isHovered }) => css`
        height: 100%;
        padding: 0.625rem 1rem;
        transition: 0.2s ease;
        margin-left: 0rem;

        &:hover {
            margin-left: ${$isHovered && '0.5rem'};
        }
    `}
`;
